import {
  ApplicationBundleTypeEnum,
  ApplicationMainModelFileTypeEnum,
  ContentTypeEnum,
  ExperimentBundleSubType,
} from "../../../generated/graphql";
import { ExperimentFieldTypes, ExperimentsTypes } from "./types";

export const maxTitleSymbols = 255;

export const maxDescriptionSymbols = 1500;

export const bundleTypeItems = [
  {
    label: "Бандл",
    entity: ApplicationBundleTypeEnum.Bundle,
    field: "bundleType",
  },
  {
    label: "Ссылка",
    entity: ApplicationBundleTypeEnum.BundleLink,
    field: "bundleLink",
  },
  {
    label: "Картинка",
    entity: ApplicationBundleTypeEnum.Photo,
    field: "bundlePhoto",
  },
];

export const surveyLabels = [
  { label: "Відображати", entity: true },
  { label: "Не відображати", entity: false },
];

export const markerLabels = [
  { label: "Есть", entity: true },
  { label: "Нет", entity: false },
];

export const LoaderProps = {
  style: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
  },
};

export enum ModelFields {
  IsMarker = "isMarker",
  MarkerPhoto = "markerPhoto",
  Photo = "photo",
  IsMap = "isMap",
  MapMarkerPhoto = "mapMarkerPhoto",
  BundleType = "bundleType",
  BundlePhoto = "bundlePhoto",
  BundleLink = "bundleLink",
  Bundles = "bundles",
  SmartNotificationId = "smartNotificationId",
  ContentPreviews = "contentPreviews",
  ContentType = "contentType",
  Tags = "tags",
}

export const mediaCardsQuantity = 6;

export const regexYouTubeUrl =
  /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;

export const videoIdGroupIndex = 5;

export const maxImageSize = 10 * 1024 * 1024;

export const aspectRatio = 16 / 9;

export const qualityArgument = 1;

export enum BundleNames {
  Ios = "IOS Bundle",
  IosManifest = "IOS Manifest",
  IosResources = "IOS Localisation",
  IosResourcesManifest = "IOS Localisation Manifest",

  Android = "Android Bundle",
  AndroidManifest = "Android Manifest",
  AndroidResources = "Android Localisation",
  AndroidResourcesManifest = "Android  Localisation Manifest",

  WebGL = "WebGL Bundle",
  WebGlManifest = "WebGL Manifest",
  WebGlResources = "WebGL Localisation",
  WebGlResourceManifests = "WebGL Localisation Manifest",

  Vr = "VR Bundle",
  VrManifest = "VR Manifest",
  VrResources = "VR Localisation",
  VrResourcesManifest = "VR Localisation Manifest",

  AndroidBoardBundle = "Android Board Bundle",
  AndroidBoardManifest = "Android Board Manifest",
  AndroidBoardResources = "Android Board Localisation",
  AndroidBoardResourcesManifest = "Android Board Localisation Manifest",

  WindowsBoardBundle = "Windows Board Bundle",
  WindowsBoardManifest = "Windows Board Manifest",
  WindowsBoardResources = "Windows Board Localisation",
  WindowsBoardResourcesManifest = "Windows Board Localisation Manifest",

  IosOptimized = "IOS optimized",
  WebGlOptimized = "WebGL optimized",
  AndroidOptimized = "Android optimized",
  IosOptimizedManifest = "IOS optimized manifest",
  WebGlOptimizedManifest = "WebGL optimized manifest",
  AndroidOptimizedManifest = "Android optimized manifest",

  WebGlBundleClothesObjects = "WebGL Bundle",
  WebGlOptimizedBundleClothesObjects = "WebGL Optimized Bundle",
  WebGlManifestClothesObjects = "WebGL Manifest",
  WebGlOptimizedManifestClothesObjects = "WebGL Optimized Manifest",
}

export enum BundleMode {
  Manifest = "manifest",
  Bundle = "bundle",
  Resources = "resources",
  ResourcesManifest = "resourcesManifest",
}

export const experiments: ExperimentsTypes[] = [
  {
    type: ContentTypeEnum.ArWebgl,
    text: "AR/3D експеримент",
  },
  {
    type: ContentTypeEnum.ExperimentVr,
    text: "VR експеримент",
  },
  {
    type: ContentTypeEnum.InteractiveExercise,
    text: "Інтерактивна вправа",
  },
  // {
  //   type: ContentTypeEnum.Quiz,
  //   text: "Вікторина",
  // },
];

export const SUBJECT_QUANTITY = 100;

export const requiredFields = [
  "name",
  "description",
  "contentType",
  "mains",
  "schoolGrades",
  "tags",
  "contentPreviews",
  "libraryContent",
];

export const invalidFileExtensions = [
  ".xbm",
  ".avif",
  ".pjp",
  ".apng",
  ".jfif",
  ".pjpeg",
  ".gif",
];

export const validImageTypes = ["image/jpeg", "image/png"];

export const wrongEqualIdMessage = `Неверный формат equalId`;
export const LIMIT_TEXT_BOOKS = 10;

export const PLATFORM_LABELS: { [key: string]: string } = {
  [ApplicationMainModelFileTypeEnum.Ios]: "IOS",
  [ApplicationMainModelFileTypeEnum.Android]: "Android",
  [ApplicationMainModelFileTypeEnum.WebGl]: "WebGL",
  [ApplicationMainModelFileTypeEnum.Vr]: "VR",
  [ApplicationMainModelFileTypeEnum.InteractiveWhiteboardAndroid]:
    "Android for board",
  [ApplicationMainModelFileTypeEnum.InteractiveWhiteboardWindows]:
    "Windows for board",
};
export const ALLOWED_PLATFORMS_BY_TYPE: { [key: string]: string[] } = {
  [ContentTypeEnum.ArWebgl]: [
    ApplicationMainModelFileTypeEnum.Ios,
    ApplicationMainModelFileTypeEnum.Android,
    ApplicationMainModelFileTypeEnum.WebGl,
    ApplicationMainModelFileTypeEnum.InteractiveWhiteboardAndroid,
    ApplicationMainModelFileTypeEnum.InteractiveWhiteboardWindows,
  ],
  [ContentTypeEnum.InteractiveExercise]: [
    ApplicationMainModelFileTypeEnum.Ios,
    ApplicationMainModelFileTypeEnum.Android,
    ApplicationMainModelFileTypeEnum.WebGl,
    ApplicationMainModelFileTypeEnum.InteractiveWhiteboardAndroid,
    ApplicationMainModelFileTypeEnum.InteractiveWhiteboardWindows,
  ],
  [ContentTypeEnum.ExperimentVr]: [ApplicationMainModelFileTypeEnum.Vr],
};

export const PLATFORM_TO_BUNDLE_MAP: { [key: string]: string[] } = {
  [ApplicationMainModelFileTypeEnum.Ios]: [
    BundleNames.Ios,
    BundleNames.IosManifest,
    BundleNames.IosResources,
    BundleNames.IosResourcesManifest,
  ],
  [ApplicationMainModelFileTypeEnum.Android]: [
    BundleNames.Android,
    BundleNames.AndroidManifest,
    BundleNames.AndroidResources,
    BundleNames.AndroidResourcesManifest,
  ],
  [ApplicationMainModelFileTypeEnum.WebGl]: [
    BundleNames.WebGL,
    BundleNames.WebGlManifest,
    BundleNames.WebGlResources,
    BundleNames.WebGlResourceManifests,
  ],
  [ApplicationMainModelFileTypeEnum.Vr]: [
    BundleNames.Vr,
    BundleNames.VrManifest,
    BundleNames.VrResources,
    BundleNames.VrResourcesManifest,
  ],
  [ApplicationMainModelFileTypeEnum.InteractiveWhiteboardAndroid]: [
    BundleNames.AndroidBoardBundle,
    BundleNames.AndroidBoardManifest,
    BundleNames.AndroidBoardResources,
    BundleNames.AndroidBoardResourcesManifest,
  ],
  [ApplicationMainModelFileTypeEnum.InteractiveWhiteboardWindows]: [
    BundleNames.WindowsBoardBundle,
    BundleNames.WindowsBoardManifest,
    BundleNames.WindowsBoardResources,
    BundleNames.WindowsBoardResourcesManifest,
  ],
};

export const BUNDLE_FIELD_MAP = {
  [ExperimentFieldTypes.Bundle]: "file",
  [ExperimentFieldTypes.Manifest]: "manifest",
  [ExperimentBundleSubType.Resources]: "resources",
  [ExperimentBundleSubType.ResourcesManifest]: "resourcesManifest",
};

 export const PLATFORM_TO_BUNDLE_URL_FIELD: Partial<Record<ApplicationMainModelFileTypeEnum, string>> = {
   [ApplicationMainModelFileTypeEnum.Ios]: "iosBundleUrl",
   [ApplicationMainModelFileTypeEnum.Android]: "androidBundleUrl",
   [ApplicationMainModelFileTypeEnum.WebGl]: "webGlBundleUrl",
   [ApplicationMainModelFileTypeEnum.Vr]: "vrBundleUrl",
   [ApplicationMainModelFileTypeEnum.InteractiveWhiteboardAndroid]: "interactiveWhiteboardAndroidBundleUrl",
   [ApplicationMainModelFileTypeEnum.InteractiveWhiteboardWindows]: "interactiveWhiteboardWindowsBundleUrl",
 };
 